import { render } from "./placeholder-panel.vue?vue&type=template&id=2dde9170&scoped=true"
import script from "./placeholder-panel.vue?vue&type=script&lang=js"
export * from "./placeholder-panel.vue?vue&type=script&lang=js"

import "./placeholder-panel.vue?vue&type=style&index=0&id=2dde9170&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jamesc\\source\\repos\\ul-web-plugins\\src\\UL.VueCadPlugin.Client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dde9170"]])

export default __exports__